exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-2e4dc8c8]{\n    border: 1px solid #ced4da;\n}\n.wrapper[data-v-2e4dc8c8]{\n    position: relative;\n}\n.loading[data-v-2e4dc8c8]{\n    opacity: 0.5;\n    pointer-events: none;\n}\n.loader[data-v-2e4dc8c8] {\n    height: 100px;\n    width: 100%;\n    text-align: center;\n    padding: 1em;\n    display: inline-block;\n    vertical-align: top;\n    z-index: 20;\n    position: absolute;\n    margin: 100px auto;\n}\n\n/*\n  Set the color of the icon\n*/\nsvg path[data-v-2e4dc8c8],\nsvg rect[data-v-2e4dc8c8] {\n    fill: #0162A7;\n}\n", ""]);

// exports
